import { useMemo } from 'react';
import { getBrandConfig } from '../config/brandConfig';

/**
 * Hook pour utiliser les classes Tailwind selon la marque
 */
export const useTailwindBrand = () => {
  const brandConfig = useMemo(() => getBrandConfig(), []);
  
  // Classes Tailwind selon la marque
  const classes = useMemo(() => {
    switch (brandConfig.name) {
      case 'verified-trainer':
        return {
          // Couleurs Verified Trainer
          primary: 'bg-vt-primary text-white',
          primaryRecto: 'text-vt-primary bg-white',
          secondary: 'bg-vt-secondary text-white',
          secondaryRecto: 'text-vt-secondary bg-white',
          input : "bg-vt-background border border-vt-primary text-vt-text",
          fontFamily : "font-acumin",
          menu: "hover:bg-vt-primary hover:text-white text-vt-primary border-2 border-vt-primary",
          button : "bg-vt-primary text-white border-vt-primary",
          bgLoginPage  : " bg-registerVt bg-cover bg-center bg-no-repeat",
          bgRegister : "bg-center bg-cover bg-no-repeat bg-registerVt",
          navHeader: "bg-vt-primary text-white /border-vt-secondary /hover:bg-vt-secondary hover:text-white lg:opacity-90",
          navHeader2: "lg:/text-vt-primary hover:bg-gray-100",

          accent: 'bg-vt-accent text-white',
          light: 'bg-vt-light text-vt-dark',
          dark: 'bg-vt-dark text-white',
          background: 'bg-vt-background',
          text: 'text-vt-text',
          success: 'bg-vt-success text-white',
          warning: 'bg-vt-warning text-vt-dark',
          error: 'text-vt-error',
          
          // Variantes
          primaryHover: 'hover:text-white border border-vt-primary hover:bg-vt-primary/70',
          secondaryHover: 'hover:bg-vt-secondary/90',
          accentHover: 'hover:bg-vt-accent/90',
          //text hover
           primaryTextHover: 'hover:text-vt-primary/70',
          
          // Bordures
          primaryBorder: 'border-vt-primary',
          secondaryBorder: 'border-vt-secondary',
          errorBorder: 'border-vt-error',
          textBorder: 'border-vt-text',
          accentBorder: 'border-vt-accent',
          backgroundBorder: '/border-vt-background',
          backgroundHover: 'hover:bg-vt-background/90',
          
          // Focus
          primaryFocus: 'focus:ring-vt-primary focus:border-vt-primary',
          secondaryFocus: 'focus:ring-vt-secondary focus:border-vt-secondary',
          //Text
          primaryText : "text-vt-primary",
          secondaryText : "text-vt-secondary",
          normal : "text-vt-text",
          //bg
          primaryBg: "bg-vt-primary",
          secondaryBg: "bg-vt-secondary",
          errorBg: "bg-vt-error",
          bgLogin :"from-[#0dcebf] via-[#34454e] to-[#8B4513]",
          bgRootLoader : "bg-gradient-to-r from-[#E8FCFB] to-[#0dcebf]",
          
          //bg-gradiant
          primaryBgGradiant : "bg-gradient-to-r from-vt-profile to-vt-primary",
          primaryBgGradiantLeft : "bg-gradient-to-l from-vt-secondary"
        };
        
        case 'declarons':
          return {
            // Couleurs Déclarons
            primary: 'bg-declarons-primary text-white',
            primaryRecto: 'text-declarons-primary bg-white',
            secondary: 'bg-declarons-secondary text-white',
            secondaryRecto: 'text-declarons-secondary bg-white',
          input : "bg-declarons-background text-declarons-text",
          fontFamily : "font-crimson",
          menu: "hover:bg-declarons-primary hover:text-white text-declarons-primary border-2 border-declarons-primary",
          button : "bg-declarons-primary text-white border-declarons-primary",
          bgLoginPage: "bg-bgLogin bg-cover bg-center bg-no-repeat",
          bgRegister : "bg-center bg-cover bg-no-repeat bg-registerDec",    
          navHeader: "bg-declarons-primary text-white /border-declarons-secondary /hover:bg-declarons-secondary hover:text-white lg:opacity-90",
          navHeader2: "lg:text-declarons-primary hover:bg-gray-100",
          
          accent: 'bg-declarons-accent text-white',
          light: 'bg-declarons-light text-declarons-dark',
          dark: 'bg-declarons-dark text-white',
          background: 'bg-declarons-background',
          text: 'text-declarons-text',
          success: 'bg-declarons-success text-white',
          warning: 'bg-declarons-warning text-declarons-dark',
          error: 'text-declarons-error',
          
          // Variantes
          primaryHover: 'hover:text-white border border-declarons-primary hover:bg-declarons-primary/70',
          secondaryHover: 'hover:bg-declarons-secondary/90',
          accentHover: 'hover:bg-declarons-accent/90',
          backgroundHover: 'hover:bg-declarons-background/90',
          
          // Bordures
          primaryBorder: 'border-declarons-primary',
          secondaryBorder: 'border-declarons-secondary',
          errorBorder: 'border-declarons-error',
          textBorder: 'border-declarons-text',
          accentBorder: 'border-declarons-accent',
          backgroundBorder: 'border-declarons-background',
          
          // Focus
          primaryFocus: 'focus:ring-declarons-primary focus:border-declarons-primary',
          secondaryFocus: 'focus:ring-declarons-secondary focus:border-declarons-secondary',
          //Text
           primaryText : "text-declarons-primary",
           secondaryText : "text-declarons-secondary",
           normal : "text-vt-text",
           //bg
           primaryBg: "bg-declarons-primary",
           secondaryBg: "bg-declarons-secondary",
           errorBg: "bg-declarons-error",
           bgLogin :"from-[#0dcebf] via-[#34454e] to-[#8B4513]",
           bgRootLoader : "bg-gradient-to-r from-[#6F80AE] to-[#001E73]",
           //bg-gradiant
           primaryBgGradiant : "bg-gradient-to-r from-declarons-profile to-declarons-primary",
           primaryBgGradiantLeft : "bg-gradient-to-r from-[#001E73] to-[#6F80AE]",
           //bg-gradiant
           bgGradiant : "bg-gradient-to-r from-declarons-primary via-pink-50 to-declarons- "
        };
        
      default: // Teach'r
        return {
          // Couleurs Teach'r (par défaut)
          primary: 'bg-brand-primary text-white',
          primaryRecto: 'text-brand-primary bg-white',
          secondary: 'bg-brand-secondary text-white',
          secondaryRecto: 'text-brand-secondary bg-white',
          input : "bg-brand-background text-brand-text",
          fontFamily : "font-nunito",
          menu: "hover:bg-brand-primary hover:text-white text-brand-primary border-2 border-brand-primary",
          button : "bg-brand-primary text-white border-brand-primary",
          bgLoginPage : "bg-center bg-cover bg-no-repeat bg-loginln ",
          bgRegister : "bg-center bg-cover bg-no-repeat bg-register ",
          navHeader: "bg-brand-primary text-white /border-brand-secondary /hover:bg-brand-secondary hover:text-white lg:opacity-90",
          navHeader2: "lg:text-brand-primary hover:bg-gray-100",

          accent: 'bg-brand-accent text-white',
          light: 'bg-brand-light text-brand-dark',
          dark: 'bg-brand-dark text-white',
          background: 'bg-brand-background',
          text: 'text-brand-text',
          success: 'bg-brand-success text-white',
          warning: 'bg-brand-warning text-brand-dark',
          error: 'text-brand-error',
          
          // Variantes
          primaryHover: 'hover:text-white border border-brand-primary hover:bg-brand-primary/70',
          secondaryHover: 'hover:bg-brand-secondary/90',
          accentHover: 'hover:bg-brand-accent/90',
          backgroundHover: 'hover:bg-brand-background/90',
          
          // Bordures
          primaryBorder: 'border-brand-primary',
          secondaryBorder: 'border-brand-secondary',
          errorBorder: 'border-brand-error',
          textBorder: 'border-brand-text',
          accentBorder: 'border-brand-accent',
          backgroundBorder: 'border-brand-background',
          
          // Focus
          primaryFocus: 'focus:ring-brand-primary focus:border-brand-primary',
          secondaryFocus: 'focus:ring-brand-secondary focus:border-brand-secondary',
           //Text
           primaryText : "text-brand-primary",
           secondaryText : "text-brand-secondary",
           normal : "text-vt-text",
           //bg
           primaryBg: "bg-brand-primary",
           secondaryBg: "bg-brand-secondary",
            errorBg: "bg-brand-error",
           bgLogin :"from-[#0dcebf] via-[#34454e] to-[#8B4513]",
           bgRootLoader : "bg-gradient-to-r from-[#92D3FF] to-[#0074E4]",
           //bg-gradiant
          primaryBgGradiant : "bg-gradient-to-r from-brand-profile to-brand-primary"
        };
    }
  }, [brandConfig.name]);
  
  // Classes communes
  const common = {
    // Layout
    container: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
    section: 'py-12 sm:py-16 lg:py-20',
    
    // Typography
    title: `text-3xl sm:text-4xl lg:text-5xl font-extrabold ${classes.fontFamily}`,
    subtitle: `text-xl sm:text-2xl lg:text-3xl font-bold ${classes.fontFamily}`,
    subtitle2: `text-lg base:text-xl lg:text-2xl font-bold ${classes.fontFamily}`,
    subtitle3: `md:text-base lg:text-lg text-sm ${classes.fontFamily}`,
    body: `md:text-base lg:text-lg text-sm ${classes.fontFamily} ${classes.text} `,
    caption: 'text-sm text-gray-600',
    
    // Buttons
    button: `px-6 py-3 rounded-lg font-semibold transition-all duration-200  ${classes.fontFamily}`,
    buttonPrimary: 'px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200',
    buttonSecondary: 'px-6 py-3 rounded-lg font-semibold border-2 transition-all duration-200',
    
    // Cards
    card: 'bg-white rounded-lg shadow-lg p-6',
    cardHover: 'bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-200',
    
    // Forms
    input: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-colors duration-200',
    label: 'block text-sm font-medium mb-2',
    
    // Spacing
    spacing: {
      xs: 'space-y-2',
      sm: 'space-y-4',
      md: 'space-y-6',
      lg: 'space-y-8',
      xl: 'space-y-12',
    },
    
    // Flexbox
    flexCenter: 'flex items-center justify-center',
    flexBetween: 'flex items-center justify-between',
    flexCol: 'flex flex-col',
    
    // Grid
    grid: 'grid gap-6',
    gridCols: {
      1: 'grid-cols-1',
      2: 'grid-cols-1 md:grid-cols-2',
      3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
      4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
    },
  };
  
  return {
    brandConfig : brandConfig,
    brand: brandConfig.name,
    classes,
    common,
    // Méthode utilitaire pour combiner des classes
    combine: (...classNames: (string | undefined | null | false)[]) => {
      return classNames.filter(Boolean).join(' ');
    },
    // Méthode pour obtenir une classe conditionnelle
    conditional: (condition: boolean, trueClass: string, falseClass: string = '') => {
      return condition ? trueClass : falseClass;
    },
  };
};

export default useTailwindBrand;




